export interface ISplitByDate<T> {
  date: string;
  data: T[];
}

export const splitDataByDate = <
  T extends { dateCreated: string }
>(
  data: T[],
  withTime = false
) => {
  const getKey = (date: string) =>
    withTime ? date : date.split('T')[0];

  const dates = Array.from(
    new Set(data.map(i => getKey(i.dateCreated)))
  );

  return dates.map(d => ({
    date: d,
    data: data.filter(i => getKey(i.dateCreated) === d),
  }));
};
